import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Routes from "./routes/index";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { store } from "./helpers";
import "./assets/scss/index.scss";
import "./index.css";
import "react-notifications/lib/notifications.css";
import "antd/dist/antd.css";
import App from "./App";
import MobileReponseShow from "pages/Dashboard/DashboardScreen/MobileReponseShow";

// import "font-awesome/css/font-awesome.min.css";

ReactDOM.render(
  <Provider store={store}>
    {/* <div className="d-md-block d-none"> */}
    {/* <Routes /> */}
    <App />
    {/* </div> */}
    {/* <div className="d-md-none d-block">
      <MobileReponseShow />
    </div> */}
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
